// Backend adresi. Yayına alırken .env dosyasında REACT_APP_API_URL tanımlayın:
//   REACT_APP_API_URL=https://app.vivasmartcare.com/api
export const API_BASE = (
	process.env.REACT_APP_API_URL || "https://app.vivasmartcare.com/api"
).replace(/\/$/, "");
